export default {
    size:'small',
  }